export default __webpack_public_path__ + "static/media/P1000-Tip-Solution-Blue.c61da89d.svg";